import { Button } from '@mui/material';
import {
  AutoCompleteController,
  InputController,
} from '../../../components';
import MultiSelect from '../../../components/formControllers/multiSelect';

export const GrowerEditForm = ({
  control,
  register,
  errors,
  onSubmit,
  handleClose,
  handleSubmit,
}) => {
  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="grid grid-cols-2 gap-x-10">
      <InputController
        label="Name"
        register={register('name')}
        error={errors?.name?.message}
        required
      />

      <InputController
        label="Code"
        register={register('code')}
        error={errors?.code?.message}
        required
      />
      <InputController
        label="Status"
        register={register('status')}
        error={errors?.status?.message}
        required
      />
      <MultiSelect
        control={control}
        name="grower"
        label="Grower"
        options={[
          { value: 'India', label: 'India' },
          { value: 'ddd', label: 'dd' },
        ]}
        //required
      />
      <InputController
        label="Mobile"
        register={register('mobile')}
        error={errors?.mobile?.message}
        required
      />
      <InputController
        label="Father name"
        register={register('fatherName')}
        error={errors?.fatherName?.message}
        required
      />
      <AutoCompleteController
        control={control}
        name="country"
        label="Country"
        options={[{ value: 'India', label: 'India' }]}
        required
      />
      <div className="col-span-full mt-8 flex justify-end">
        <Button variant="outlined" onClick={handleClose}>
          Cancel
        </Button>
        <Button
          variant="contained"
          type="submit"
          sx={{
            ml: 2,
            backgroundColor: 'rgba(0,105,112,1)',
          }}>
          Save
        </Button>
      </div>
    </form>
  );
};
